<template>
  <div class="remove">
    <div class="remove-top">
      <div class="remove-top__name">移除单</div>
    </div>
    <div class="remove-table">
      <Table :head="removeOrderTableHead" width="1654" height="550"></Table>
    </div>
  </div>
</template>

<script>
import { OrderNewModule } from './class'
import Table from 'components/common/Table.vue'
export default {
  name: 'removeOrder',
  components: {
    Table
  },
  data(){
    return {
      removeOrderTableHead: OrderNewModule.NEWREMOVEORDERTABLEHEAD()
    }
  }
}
</script>

<style lang="scss" scoped>
.remove{
  width: 1800px;
  &-top{
    display: flex;
    justify-content: space-between;
    margin: 10px 0;
    &__name{
      font-size: 16px;
      font-weight: bold;
      color: black;
    }
  }
}
</style>
